import React from 'react';

import { graphql } from 'gatsby';

import { MewaAdvantagesIcon } from '@mewa/types';
import { IconGrid, mewaAdvantagesIconMap } from '@mewa/ui';

import { StrapiComponentType } from '../types';
import { MewaEssentialsSection } from './types';

export const AdvantagesFragment = graphql`
  fragment AdvantagesFragment on STRAPI__COMPONENT_MEWA_ESSENTIALS_ADVANTAGES {
    tabTitle
    iconList {
      Icons {
        icon
        subtitle
        title
      }
    }
    strapi_component
  }
`;

export const componentName = 'mewa-essentials.advantages';

type IconData = {
  icon: MewaAdvantagesIcon;
  title?: string | null;
  subtitle?: string | null;
};

export type AdvantagesData = StrapiComponentType<typeof componentName> & {
  iconList: {
    Icons: IconData[];
  };
};

export const isAdvantages = (
  component: MewaEssentialsSection,
): component is MewaEssentialsSection<AdvantagesData> => {
  return component.strapi_component === componentName;
};

export const StrapiAdvantages = ({ data }: { data: AdvantagesData }) => {
  return (
    <IconGrid
      icons={data.iconList.Icons.map((iconData) => ({
        ...iconData,
        Icon: mewaAdvantagesIconMap[iconData.icon],
      }))}
    />
  );
};
